export default "__VITE_ASSET__a1c013fa__"